import {
  pbDemo64ContentData,
  pbDemoData,
  pbDemoMoreContentData,
  pbHealthBeautyData,
  pbHouseholdData,
} from "./data";

export const pbDemo = {
  chart: {
    type: "packedbubble",
  },
  title: {
    text: "Packed Bubble Chart",
  },
  subtitle: {
    text: "Category Value - <b>Total Market</b>	£767,041,698	-2.7% <br />	Category Value - <b>Impulse</b>	£10,157,852	-9.0%",
  },
  colors: [
    "rgba(255, 99, 132, 1)",
    "rgba(54, 162, 235, 1)",
    "rgba(255, 206, 86, 1)",
  ],
  tooltip: {
    hideDelay: 0,
    useHTML: true,
    pointFormat:
      "<b>{point.name}:</b> {point.value}% <br /> <i>{point.valueShare}</i> ",
  },
  plotOptions: {
    packedbubble: {
      minPointLength: 1,
      minSize: "40%",
      maxSize: "100%",
      layoutAlgorithm: {
        splitSeries: false,
        gravitationalConstant: 0.02,
        enableSimulation: false,
      },
      dataLabels: {
        enabled: true,
        format: "{point.name}",
        formatter: function () {
          if (this.y !== 0) {
            return this.y;
          }
        },
        filter: {
          property: "y",
          operator: ">",
          value: 1,
        },
        style: {
          color: "black",
          textOutline: "none",
          fontWeight: "normal",
          "word-break": "break-word",
          width: 50,
        },
      },
    },
  },
  series: pbDemoData,
};

export const pbDemoMoreContent = {
  chart: {
    type: "packedbubble",
  },
  title: {
    text: "Packed Bubble Chart",
  },
  subtitle: {
    text: "Category Value - <b>Total Market</b>	£767,041,698	-2.7% <br />	Category Value - <b>Impulse</b>	£10,157,852	-9.0%",
  },
  colors: [
    "rgba(255, 99, 132, 1)",
    "rgba(54, 162, 235, 1)",
    "rgba(255, 206, 86, 1)",
  ],
  tooltip: {
    hideDelay: 0,
    useHTML: true,
    pointFormat:
      "<b>{point.name}:</b> {point.value}% <br /> <i>{point.valueShare}</i> ",
  },
  plotOptions: {
    packedbubble: {
      minPointLength: 1,
      minSize: "40%",
      maxSize: "100%",
      layoutAlgorithm: {
        splitSeries: false,
        gravitationalConstant: 0.035,
        enableSimulation: false,
      },
      dataLabels: {
        enabled: true,
        format: "{point.name}",
        formatter: function () {
          if (this.y !== 0) {
            return this.y;
          }
        },
        filter: {
          property: "y",
          operator: ">",
          value: 1,
        },
        style: {
          color: "black",
          textOutline: "none",
          fontWeight: "normal",
          "word-break": "break-word",
          width: 50,
        },
      },
    },
  },
  series: pbDemoMoreContentData,
};

export const pbDemo64Content = {
  chart: {
    type: "packedbubble",
  },
  title: {
    text: "Packed Bubble Chart",
  },
  subtitle: {
    text: "Category Value - <b>Total Market</b>	£767,041,698	-2.7% <br />	Category Value - <b>Impulse</b>	£10,157,852	-9.0%",
  },
  colors: [
    "rgba(255, 99, 132, 1)",
    "rgba(54, 162, 235, 1)",
    "rgba(255, 206, 86, 1)",
  ],
  tooltip: {
    hideDelay: 0,
    useHTML: true,
    pointFormat:
      "<b>{point.name}:</b> {point.value}% <br /> <i>{point.valueShare}</i> ",
  },
  plotOptions: {
    packedbubble: {
      minPointLength: 1,
      minSize: "40%",
      maxSize: "100%",
      layoutAlgorithm: {
        splitSeries: false,
        gravitationalConstant: 0.035,
        enableSimulation: false,
      },
      dataLabels: {
        enabled: true,
        format: "{point.name}",
        formatter: function () {
          if (this.y !== 0) {
            return this.y;
          }
        },
        filter: {
          property: "y",
          operator: ">",
          value: 1,
        },
        style: {
          color: "black",
          textOutline: "none",
          fontWeight: "normal",
          "word-break": "break-word",
          width: 50,
        },
      },
    },
  },
  series: pbDemo64ContentData,
};

export const pbHealthBeautyBaby = {
  chart: {
    type: "packedbubble",
    marginTop: 50,
  },
  credits: {
    enabled: false,
  },
  legend: {
    align: "top",
    verticalAlign: "top",
    layout: "horizontal",
    x: -17.5,
    y: 0,
    itemStyle: {
      color: "#092F50",
    },
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 860,
        },
        chartOptions: {
          chart: {
            marginTop: 0,
          },
          legend: {
            align: "center",
            verticalAlign: "bottom",
            layout: "horizontal",
            x: 0,
            y: 0,
          },
          plotOptions: {
            packedbubble: {
              minSize: "100%",
            },
          },
        },
      },
    ],
  },

  title: {
    useHTML: true,
    text: "Health, Beauty  <br /> & Baby",
    align: "center",
    y: 0, //
    x: -90,
    style: {
      fontSize: "25px",
      color: "black",
      fontWeight: "bold",
    },
  },
  colors: [
    "rgba(37, 129, 196, 1)",
    "rgba(37, 129, 196, 0.6)",
    "rgba(37, 129, 196,  0.3)",
  ],
  tooltip: {
    hideDelay: 0,
    useHTML: true,
    pointFormatter: function() {
      return '<b>' + this.name + ':</b> £' + (this.value % 1 === 0 ? this.value.toFixed(1) : this.value) + 'm';
  }
  },
  plotOptions: {
    series: {
      marker: {
        fillOpacity: 1,
      },
      dataLabels: {
        style: {
          "word-break": "break-word",
          width: "50px",
          "text-align": "center",
        },
      },
    },
    packedbubble: {
      minSize: "40%",
      maxSize: "120%",
      marker: {
        lineColor: "transparent",
      },
      layoutAlgorithm: {
        splitSeries: false,
        gravitationalConstant: 0.01,
        enableSimulation: false,
      },
      dataLabels: {
        enabled: true,
        format: "{point.name}",
        filter: {
          property: "y",
          operator: ">",
          value: 0,
        },
        style: {
          color: "black",
          textOutline: "none",
        },
      },
    },
    formatter: function() {
      // Ensure that decimal values with ".0" are always displayed
      return '<b>' + this.point.name + ':</b> ' + this.point.value.toFixed(1);
  }
  },

  series: pbHealthBeautyData,
};

export const pbHouseHold = {
  chart: {
    type: "packedbubble",
    marginTop: 50,
  },

  legend: {
    align: "top",
    verticalAlign: "top",
    layout: "horizontal",
    x: -17.5,
    y: 0,
  },
  credits: {
    enabled: false,
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 860,
        },
        chartOptions: {
          chart: {
            marginTop: 0,
          },
          legend: {
            align: "center",
            verticalAlign: "bottom",
            layout: "horizontal",
            x: 0,
            y: 0,
          },
          plotOptions: {
            packedbubble: {
              minSize: "100%",
            },
          },
        },
      },
    ],
  },

  title: {
    useHTML: true,
    text: "HouseHold",
    align: "center",
    y: 20, //
    x: -111,
    style: {
      fontSize: "25px",
      color: "black",
      fontWeight: "bold",
    },
  },
  colors: [
    "rgba(37, 129, 196, 1)",
    "rgba(37, 129, 196, 0.6)",
    "rgba(37, 129, 196,  0.3)",
  ],
  tooltip: {
    hideDelay: 0,
    useHTML: true,
    pointFormatter: function() {
      return '<b>' + this.name + ':</b> £' + (this.value % 1 === 0 ? this.value.toFixed(1) : this.value) + 'm';
  }
  },
  plotOptions: {
    series: {
      marker: {
        fillOpacity: 1,
      },
      dataLabels: {
        style: {
          "word-break": "break-word",
          width: "50px",
          "text-align": "center",
        },
      },
    },
    packedbubble: {
      minSize: "40%",
      maxSize: "120%",
      marker: {
        lineColor: "transparent",
      },
      layoutAlgorithm: {
        splitSeries: false,
        gravitationalConstant: 0.01,
        enableSimulation: false,
      },
      dataLabels: {
        enabled: true,
        format: "{point.name}",
        filter: {
          property: "y",
          operator: ">",
          value: 0,
        },
        style: {
          color: "black",
          textOutline: "none",
        },
      },
    },
  },

  series: pbHouseholdData,
};
